module.exports = __webpack_public_path__ + "img/100-produtos.d13f08ab.jpeg";